define.alias("ember-math-helpers/helpers/acosh", "media/helpers/acosh");